import { z } from 'zod'

export const obituarySchema = z.object({
  name: z.string().min(1, 'Required').max(200),
  age: z.coerce.number().int().min(0).max(120).optional().or(z.literal(NaN)),
  residence: z.string().max(200).optional().or(z.literal('')),
  origin: z.string().max(200).optional().or(z.literal('')),
  dateOfDeath: z.date().nullable().optional(),
  photoUrl: z.string().url().max(1024).optional().or(z.literal('')),
  content: z.string().optional().or(z.literal('')),
  published: z.boolean().optional(),
})

export type FormValues = z.infer<typeof obituarySchema>
export type FormInput = z.input<typeof obituarySchema>
